module.exports = __webpack_public_path__ + "img/digital_bg.d50e1a85.png";